export default __webpack_public_path__ + "static/media/heropxr.f122d114.jxr";